<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('agreement')" :class="{'active': section === 'agreement'}">Līguma informācija</div>
            <div class="menuItem" @click="changeSection('act')" :class="{'active': section === 'act'}">Akta informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div class="section" v-if="section == 'agreement'">
                    <div class="sectionTitle">Līguma informācija</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Līguma informācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_number">Līguma numurs</label>
                                    <input type="text" id="agreement_number" v-model="agreement_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_date">Līguma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="agreement_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_date">Līguma termiņš</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="agreement_due_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_page_count">Lapu skaits</label>
                                    <input type="text" id="agreement_page_count" v-model="agreement_page_count" class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="subsection">
                            <div class="title">
                                Muzeja puses dati
                            </div>
                            <div class="actions">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_giver_firstname">Vārds</label>
                                    <input type="text" id="agreement_giver_firstname" v-model="agreement_giver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_giver_lastname">Uzvārds</label>
                                    <input type="text" id="agreement_giver_lastname" v-model="agreement_giver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_giver_position">Amats</label>
                                    <input type="text" id="agreement_giver_position" v-model="agreement_giver_position" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_giver_legal_basis">Juridiskais pamats</label>
                                    <input type="text" id="agreement_giver_legal_basis" v-model="agreement_giver_legal_basis" class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="subsection">
                            <div class="title">
                                Otrās puses dati
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="agreement_receiver_type">Personas veids</label>
                                    <select name="agreement_receiver_type" id="agreement_receiver_type" v-model="agreement_receiver_type" class="form-control">
                                        <option value="legal_person">Juridiska persona</option>
                                        <option value="individual">Fiziska persona</option>
                                    </select>
                                </div>
                            </div>
                            <hr>
                            <div class="col-3" v-if="agreement_receiver_type == 'legal_person'">
                                <div class="form-group">
                                    <label for="agreement_receiver_institution_name">Institūcijas nosaukums</label>
                                    <input type="text" id="agreement_receiver_institution_name" v-model="agreement_receiver_institution_name" class="form-control">
                                </div>
                            </div>
                            <div class="col-3" v-if="agreement_receiver_type == 'legal_person'">
                                <div class="form-group">
                                    <label for="agreement_receiver_position">Amats</label>
                                    <input type="text" id="agreement_receiver_position" v-model="agreement_receiver_position" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_receiver_firstname">Vārds</label>
                                    <input type="text" id="agreement_receiver_firstname" v-model="agreement_receiver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_receiver_lastname">Uzvārds</label>
                                    <input type="text" id="agreement_receiver_lastname" v-model="agreement_receiver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_receiver_address">Adrese</label>
                                    <input type="text" id="agreement_receiver_address" v-model="agreement_receiver_address" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_receiver_reg_nr">Reģ.Nr. / Pers.kods</label>
                                    <input type="text" id="agreement_receiver_reg_nr" v-model="agreement_receiver_reg_nr" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Līguma dati
                            </div>
                            <div class="actions">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="agreement_storage_address">Glabāšanas vieta</label>
                                    <input type="text" id="agreement_storage_address" v-model="agreement_storage_address" class="form-control">
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="form-group">
                                    <label for="agreement_special_rules">Speciālie noteikumi</label>
                                    <input type="text" id="agreement_special_rules" v-model="agreement_special_rules" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_standard_fee_eur">Standarta maksa (EUR)</label>
                                    <input type="text" id="agreement_standard_fee_eur" v-model="agreement_standard_fee_eur" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_usage_fee_eur">Lietošanas maksa (EUR)</label>
                                    <input type="text" id="agreement_usage_fee_eur" v-model="agreement_usage_fee_eur" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_total_fee_eur">Samaksa kopā (EUR)</label>
                                    <input type="text" id="agreement_total_fee_eur" v-model="agreement_total_fee_eur" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_date">Samaksas termiņš</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="agreement_fee_due_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="agreement_receiver_bank_title">Saņēmēja banka</label>
                                    <input type="text" id="agreement_receiver_bank_title" v-model="agreement_receiver_bank_title" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="agreement_receiver_bank_code">Bankas kods</label>
                                    <input type="text" id="agreement_receiver_bank_code" v-model="agreement_receiver_bank_code" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="agreement_receiver_bank_account_number">Bankas konts</label>
                                    <input type="text" id="agreement_receiver_bank_account_number" v-model="agreement_receiver_bank_account_number" class="form-control">
                                </div>
                            </div>
                        </div>

                      <div class="subsection">
                        <div class="title">
                          Kontaktpersonu informācija
                        </div>
                        <div class="actions">

                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="giver_contact_person">Deponētāja kontaktpersona</label>
                            <input type="text" id="giver_contact_person" v-model="giver_contact_person" class="form-control">
                          </div>
                          <div class="form-group">
                            <label for="receiver_contact_person">Deponējuma saņēmēja kontaktpersona</label>
                            <input type="text" id="receiver_contact_person" v-model="receiver_contact_person" class="form-control">
                          </div>
                        </div>
                      </div>
                        <hr>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section" v-if="section == 'act'">
                    <div class="sectionTitle">Akta informācija</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Akta pamatdati
                            </div>
                          <div class="actions"><button v-if="reference_act_id" class="btn btn-sm btn-primary" @click="populateWithDataFromReferenceAct">Aizpildīt ar datiem no pamata akta</button></div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_number">Akta numurs</label>
                                    <input type="text" id="act_number" v-model="act_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                              <div class="form-group">
                                <label for="act_type">Akta veids</label>
                                <select name="act_type" id="act_type" v-model="act_type" class="form-control">
                                  <option value="give">Izsniegšanas</option>
                                  <option value="give_with_reference">Izsniegšana (papildus)</option>
                                  <option value="give_with_reference_extension">Izsniegšana (pagarinājums)</option>
                                  <option value="receive_with_reference">Saņemšana (papildus)</option>
                                </select>
                              </div>
                            </div>
                          <div class="col-4">
                            <div class="form-group">
                              <label for="reference_act_id">Pamata akts</label>
                              <select name="reference_act_id" id="reference_act_id" v-model="reference_act_id" class="form-control"
                                      :disabled="act_type == 'give' || act_type == 'receive'">
                                <option :value="null">Nav norādīts</option>
                                <option v-for="act in external_acts" :key="act.id" :value="act.id" v-if="act.id != id">Nr. {{act.act_number}} / {{normalDate(act.act_date)}}</option>
                              </select>
                              <small class="muted">Tikai papildus aktiem</small>
                            </div>
                          </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="agreement_date">Akta datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="agreement_date">Termiņš</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_due_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="purpose">Mērķis (līgumam)</label>
                                    <input type="text" id="purpose" v-model="purpose" class="form-control">
                                </div>
                            </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label for="act_basis">Pamatojums (aktam)</label>
                              <input type="text" id="act_basis" v-model="act_basis" class="form-control">
                            </div>
                          </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="annex_to_the_act">Pielikumi</label>
                                    <textarea type="text" id="annex_to_the_act" v-model="annex_to_the_act" class="form-control">{{annex_to_the_act}}</textarea>
                                    <small>Brīvā tekstā</small>
                                </div>
                            </div>
                        </div>
                            <div class="subsection">
                                <div class="title">
                                    Muzeja puses dati
                                </div>
                                <div class="actions"><button class="btn btn-sm btn-primary" @click="populateActDataWithCurrentUser()">Aizpildīt ar saviem datiem</button></div>
                            </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_giver_firstname">Vārds</label>
                                    <input type="text" id="act_giver_firstname" v-model="act_giver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_giver_lastname">Uzvārds</label>
                                    <input type="text" id="act_giver_lastname" v-model="act_giver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_giver_position">Amats</label>
                                    <input type="text" id="act_giver_position" v-model="act_giver_position" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Otras puses dati
                            </div>
                            <div class="actions"><button class="btn btn-sm btn-primary" @click="populateWithDataFromAgreement()">Aizpildīt ar datiem no līguma</button></div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="act_receiver_type">Personas veids</label>
                                    <select name="act_receiver_type" id="act_receiver_type" v-model="act_receiver_type" class="form-control">
                                        <option value="legal_person">Juridiska persona</option>
                                        <option value="individual">Fiziska persona</option>
                                    </select>
                                </div>
                            </div>
                            <hr>
                            <div class="col-3" v-if="act_receiver_type=='legal_person'">
                                <div class="form-group">
                                    <label for="act_receiver_institution_name">Institūcijas nosaukums</label>
                                    <input type="text" id="act_receiver_institution_name" v-model="act_receiver_institution_name" class="form-control">
                                </div>
                            </div>
                            <div class="col-3" v-if="act_receiver_type=='legal_person'">
                                <div class="form-group">
                                    <label for="act_receiver_position">Amats</label>
                                    <input type="text" id="act_receiver_position" v-model="act_receiver_position" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_receiver_firstname">Vārds</label>
                                    <input type="text" id="act_receiver_firstname" v-model="act_receiver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_receiver_lastname">Uzvārds</label>
                                    <input type="text" id="act_receiver_lastname" v-model="act_receiver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_receiver_address">Adrese</label>
                                    <input type="text" id="act_receiver_address" v-model="act_receiver_address" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_receiver_reg_nr">Reg.nr./Pers. kods</label>
                                    <input type="text" id="	act_receiver_reg_nr" v-model="	act_receiver_reg_nr" class="form-control">
                                </div>
                            </div>
                        </div>
                            <div class="subsection">
                                <div class="title">
                                    Atbildīgā glabāšanā pieņēma (aizpilda tikai aktiem par saņemšanu)
                                </div>
                                <div class="actions"><button class="btn btn-sm btn-primary" @click="populateActPersonInChargeWithCurrentUser()">Aizpildīt ar saviem datiem</button></div>
                            </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_receiver_person_in_charge_firstname">Vārds</label>
                                    <input type="text" id="act_receiver_person_in_charge_firstname" v-model="act_receiver_person_in_charge_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_receiver_person_in_charge_lastname">Uzvārds</label>
                                    <input type="text" id="act_receiver_person_in_charge_lastname" v-model="act_receiver_person_in_charge_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_receiver_person_in_charge_position">Amats</label>
                                    <input type="text" id="act_receiver_person_in_charge_position" v-model="act_receiver_person_in_charge_position" class="form-control">
                                </div>
                            </div>

                        </div>
                      <div class="subsection">
                                <div class="title">
                                    Akta sagatavotāja informācija
                                </div>
                                <div class="actions"><button class="btn btn-sm btn-primary" @click="populateActAuthorWithCurrentUser()">Aizpildīt ar saviem datiem</button></div>
                            </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_firstname">Vārds</label>
                                    <input type="text" id="act_author_firstname" v-model="act_author_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_lastname">Uzvārds</label>
                                    <input type="text" id="act_author_lastname" v-model="act_author_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_position">Amats</label>
                                    <input type="text" id="act_author_position" v-model="act_author_position" class="form-control">
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section"  v-if="section=='items'">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="actions">
                            <items-search-component></items-search-component>
                        </div>
                        <table class="table">
                            <thead class="bg-primary text-white">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Nosaukums</th>
                                <th>Kolekcija</th>
                                <th>Apraksts</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/thumb/'+item.featured_image.file_name"></td>
                                <td style="width:120px;">
                                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                                </td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td>{{item.description}}</td>
                                <td>
                                    <div class="actions">
                                        <item-view-component
                                            :key="'view-component-'+item.id"
                                            :item="item"
                                            :user="user"
                                            :copyrights="copyrights"
                                        ></item-view-component>
                                        <div @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>

                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="inner">
                    <div class="section">
                        <div class="sectionTitle">Darbības</div>
                        <div class="sectionContent text-center">
                            <button class="btn btn-primary" @click="save()">Saglabāt informāciju</button>
                            <hr>
                          <div class="col-12 text-center">
                            <a :href="'/external-acts/generate-act/'+id" class="btn btn-primary m-1" target="_blank" >Ģenerēt aktu</a><br>
                          </div>
                          <div class="col-12 text-center">
                            <a :href="'/external-acts/generate-act/'+id+'?edoc=1'" class="btn btn-primary m-1" target="_blank" >Ģenerēt el. aktu</a><br>
                          </div>



                          <hr>

                            <a :href="'/external-acts/generate-items-list/'+id" class="btn btn-primary m-1" target="_blank" >Ģenerēt priekšmetu sarakstu</a>
                            <a :href="'/external-acts/generate-items-list/'+id+'?show_images=1'" class="btn btn-primary m-1" target="_blank" >Ģenerēt priekšmetu sarakstu (ar attēlu)</a>
                            <div v-if="act_type == 'give'">
                              <hr>
                              <div class="col-12 text-center">
                              <a :href="'/external-acts/generate-agreement/'+id" class="btn btn-primary m-1" target="_blank" >Ģenerēt deponēšanas līgumu</a>
                              </div>
                              <div class="col-12 text-center">
                              <a :href="'/external-acts/generate-agreement/'+id+'?edoc=1'" class="btn btn-primary" target="_blank" >Ģenerēt el. līgumu</a>
                              </div>
                            </div>


                        </div>
                    </div>
                    <div class="section" v-if="section == 'items'">
                        <div class="sectionTitle">Pievienošana</div>
                        <div class="sectionContent">
                            <div class="row">
                                <div class="col-12 text-left">
                                    <div class="form-group">
                                        <get-from-external-act></get-from-external-act>
                                    </div>
                                    <div class="form-group">
                                        <get-from-internal-act></get-from-internal-act>
                                    </div>
                                    <div class="form-group">
                                        <researchers-lists></researchers-lists>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="section">
                        <div class="sectionTitle">Papildus informācija</div>
                        <div class="sectionContent">
<!--                            <div class="form-group">-->
<!--                                <label for="agreement_extend_date">Termiņa pagarinājums</label>-->
<!--                                <v-date-picker-->
<!--                                    :popover="{ visibility: 'click' }"-->
<!--                                    mode="single"-->
<!--                                    v-model="agreement_extend_date"-->
<!--                                    :type="'date'"-->
<!--                                    :locale="'LV'"-->
<!--                                    color="teal"-->
<!--                                    :masks="{-->
<!--                                            input: ['DD.MM.YYYY']-->
<!--                                        }"-->
<!--                                />-->
<!--                                <small class="muted">Aizpilda, ja līgumam noteikt pagarinājums.</small>-->
<!--                            </div>-->
<!--                            <div class="form-group">-->
<!--                                <label for="agreement_receive_date">Saņemšanas datums</label>-->
<!--                                <v-date-picker-->
<!--                                    :popover="{ visibility: 'click' }"-->
<!--                                    mode="single"-->
<!--                                    v-model="agreement_receive_date"-->
<!--                                    :type="'date'"-->
<!--                                    :locale="'LV'"-->
<!--                                    color="teal"-->
<!--                                    :masks="{-->
<!--                                            input: ['DD.MM.YYYY']-->
<!--                                        }"-->
<!--                                />-->
<!--                                <small class="muted">Datums, kad priekšmeti saņemti atpakaļ muzejā.</small>-->
<!--                            </div>-->
                            <div class="form-group">
                                <label for="notes">Piezīmes</label>
                                <textarea type="text" id="notes" v-model="notes" class="form-control">{{notes}}</textarea>
                                <small>Informācija parādās reģistrācijas grāmatā</small>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            display:flex;
            align-items: center;
            margin-left:auto;
            margin-bottom:0px;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>

<script>
import ItemViewComponent from "../items/ItemViewComponent";
export default{
    components: {ItemViewComponent},
    props:['act','current_user','user','copyrights','external_acts'],
    mounted()
    {
        this.items=this.$props.act.items;

        this.id = this.$props.act.id;
        this.agreement_number = this.$props.act.agreement_number;
        this.agreement_date = moment(this.$props.act.agreement_date, moment.ISO_8601)._d;
        this.agreement_extend_date = moment(this.$props.act.agreement_extend_date, moment.ISO_8601)._d;
        this.agreement_receive_date = moment(this.$props.act.agreement_receive_date, moment.ISO_8601)._d;
        this.agreement_giver_firstname = this.$props.act.agreement_giver_firstname;
        this.agreement_giver_lastname = this.$props.act.agreement_giver_lastname;
        this.agreement_giver_position = this.$props.act.agreement_giver_position;
        this.agreement_giver_legal_basis = this.$props.act.agreement_giver_legal_basis;
        this.agreement_receiver_type = this.$props.act.agreement_receiver_type;
        this.agreement_receiver_institution_name = this.$props.act.agreement_receiver_institution_name;
        this.agreement_receiver_position = this.$props.act.agreement_receiver_position;
        this.agreement_receiver_firstname = this.$props.act.agreement_receiver_firstname;
        this.agreement_receiver_lastname = this.$props.act.agreement_receiver_lastname;
        this.agreement_receiver_address = this.$props.act.agreement_receiver_address;
        this.agreement_receiver_reg_nr = this.$props.act.agreement_receiver_reg_nr;
        this.agreement_storage_address = this.$props.act.agreement_storage_address;
        this.agreement_due_date = moment(this.$props.act.agreement_due_date, moment.ISO_8601)._d;
        this.agreement_standard_fee_eur = this.$props.act.agreement_standard_fee_eur;
        this.agreement_usage_fee_eur = this.$props.act.agreement_usage_fee_eur;
        this.agreement_total_fee_eur = this.$props.act.agreement_total_fee_eur;
        this.agreement_fee_due_date = moment(this.$props.act.agreement_fee_due_date, moment.ISO_8601)._d;
        this.agreement_page_count = this.$props.act.agreement_page_count;
        this.agreement_special_rules = this.$props.act.agreement_special_rules;
        this.agreement_receiver_bank_title = this.$props.act.agreement_receiver_bank_title;
        this.agreement_receiver_bank_code = this.$props.act.agreement_receiver_bank_code;
        this.agreement_receiver_bank_account_number = this.$props.act.agreement_receiver_bank_account_number;
        this.act_number = this.$props.act.act_number;
        this.purpose = this.$props.act.purpose;
        this.act_giver_firstname = this.$props.act.act_giver_firstname;
        this.act_giver_lastname = this.$props.act.act_giver_lastname;
        this.act_giver_position = this.$props.act.act_giver_position;
        this.act_giver_legal_basis = this.$props.act.act_giver_legal_basis;
        this.act_receiver_type = this.$props.act.act_receiver_type;
        this.act_receiver_institution_name = this.$props.act.act_receiver_institution_name;
        this.act_receiver_position = this.$props.act.act_receiver_position;
        this.act_receiver_firstname = this.$props.act.act_receiver_firstname;
        this.act_receiver_lastname = this.$props.act.act_receiver_lastname;
        this.act_receiver_address = this.$props.act.act_receiver_address;
        this.act_receiver_reg_nr = this.$props.act.act_receiver_reg_nr;
        this.act_due_date = moment(this.$props.act.act_due_date, moment.ISO_8601)._d;
        this.act_author_position = this.$props.act.act_author_position;
        this.act_author_firstname = this.$props.act.act_author_firstname;
        this.act_author_lastname = this.$props.act.act_author_lastname;
        this.act_date = moment(this.$props.act.act_date, moment.ISO_8601)._d;
        this.annex_to_the_act = this.$props.act.annex_to_the_act;
        this.act_type = this.$props.act.act_type;
        this.reference_act_id = this.$props.act.reference_act_id;
        this.notes = this.$props.act.notes;
        this.act_basis = this.$props.act.act_basis;
        this.receiver_contact_person = this.$props.act.receiver_contact_person;
        this.giver_contact_person = this.$props.act.giver_contact_person;
        this.act_receiver_person_in_charge_firstname = this.$props.act.act_receiver_person_in_charge_firstname;
        this.act_receiver_person_in_charge_lastname = this.$props.act.act_receiver_person_in_charge_lastname;
        this.act_receiver_person_in_charge_position = this.$props.act.act_receiver_person_in_charge_position;

        var that = this;
        EventBus.$on('add_item_to_list',item_id =>{
            axios.post('/external-acts/add-item-to-list/'+that.id,
                {
                    item_id: item_id
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.act.items;
                    that.$toast.open(response.data.message);
                }
                if(response.data.status == 'info')
                {
                    that.$toast.warning(response.data.message);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.warning(response.data.message);
                }
            });
        });
        EventBus.$on('add_items_to_list',items_ids =>{
            axios.post('/external-acts/add-items-to-list/'+that.id,
                {
                    items_ids: items_ids
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.act.items;
                    that.$toast.open(response.data.message);
                }
            });
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });
    },
    methods:{
        populateWithDataFromReferenceAct()
        {
          var that = this;
          axios.post('/external-acts/get-data-for-population/' + that.reference_act_id)
              .then(response => {
            if (response.data.status == 'ok') {
              that.agreement_number = response.data.act.agreement_number;
              that.agreement_date = moment(response.data.act.agreement_date, moment.ISO_8601)._d;
              that.agreement_extend_date = moment(response.data.act.agreement_extend_date, moment.ISO_8601)._d;
              that.agreement_receive_date = moment(response.data.act.agreement_receive_date, moment.ISO_8601)._d;
              that.agreement_giver_firstname = response.data.act.agreement_giver_firstname;
              that.agreement_giver_lastname = response.data.act.agreement_giver_lastname;
              that.agreement_giver_position = response.data.act.agreement_giver_position;
              that.agreement_giver_legal_basis = response.data.act.agreement_giver_legal_basis;
              that.agreement_receiver_type = response.data.act.agreement_receiver_type;
              that.agreement_receiver_institution_name = response.data.act.agreement_receiver_institution_name;
              that.agreement_receiver_position = response.data.act.agreement_receiver_position;
              that.agreement_receiver_firstname = response.data.act.agreement_receiver_firstname;
              that.agreement_receiver_lastname = response.data.act.agreement_receiver_lastname;
              that.agreement_receiver_address = response.data.act.agreement_receiver_address;
              that.agreement_receiver_reg_nr = response.data.act.agreement_receiver_reg_nr;
              that.agreement_storage_address = response.data.act.agreement_storage_address;
              that.agreement_due_date = moment(response.data.act.agreement_due_date, moment.ISO_8601)._d;
              that.agreement_standard_fee_eur = response.data.act.agreement_standard_fee_eur;
              that.agreement_usage_fee_eur = response.data.act.agreement_usage_fee_eur;
              that.agreement_total_fee_eur = response.data.act.agreement_total_fee_eur;
              that.agreement_fee_due_date = moment(response.data.act.agreement_fee_due_date, moment.ISO_8601)._d;
              that.agreement_page_count = response.data.act.agreement_page_count;
              that.agreement_special_rules = response.data.act.agreement_special_rules;
              that.agreement_receiver_bank_title = response.data.act.agreement_receiver_bank_title;
              that.agreement_receiver_bank_code = response.data.act.agreement_receiver_bank_code;
              that.agreement_receiver_bank_account_number = response.data.act.agreement_receiver_bank_account_number;
              // that.act_number = response.data.act.act_number;
              that.purpose = response.data.act.purpose;
              that.act_giver_firstname = response.data.act.act_giver_firstname;
              that.act_giver_lastname = response.data.act.act_giver_lastname;
              that.act_giver_position = response.data.act.act_giver_position;
              that.act_giver_legal_basis = response.data.act.act_giver_legal_basis;
              that.act_receiver_type = response.data.act.act_receiver_type;
              that.act_receiver_institution_name = response.data.act.act_receiver_institution_name;
              that.act_receiver_position = response.data.act.act_receiver_position;
              that.act_receiver_firstname = response.data.act.act_receiver_firstname;
              that.act_receiver_lastname = response.data.act.act_receiver_lastname;
              that.act_receiver_address = response.data.act.act_receiver_address;
              that.act_receiver_reg_nr = response.data.act.act_receiver_reg_nr;
              // that.act_due_date = moment(response.data.act.act_due_date, moment.ISO_8601)._d;
              that.act_author_position = response.data.act.act_author_position;
              that.act_author_firstname = response.data.act.act_author_firstname;
              that.act_author_lastname = response.data.act.act_author_lastname;
              // that.act_date = moment(response.data.act.act_date, moment.ISO_8601)._d;
              that.annex_to_the_act = response.data.act.annex_to_the_act;
              that.act_basis = response.data.act.act_basis;
              that.act_receiver_person_in_charge_firstname = response.data.act.act_receiver_person_in_charge_firstname;
              that.act_receiver_person_in_charge_lastname = response.data.act.act_receiver_person_in_charge_lastname;
              that.act_receiver_person_in_charge_position = response.data.act.act_receiver_person_in_charge_position;
              // that.act_type = response.data.act.act_type;
              // that.reference_act_id = response.data.act.reference_act_id;
              that.notes = response.data.act.notes;
              that.$toast.open(response.data.message);
              that.save();
            }
            if (response.data.status == 'error') {
              that.$toast.warning(response.data.message);
            }
          });
          
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
                if(this.pagination.current_page+1 <= this.pagination.total_page_count)
                {
                    this.search(this.pagination.current_page+1);
                }

            }
        },
        populateActAuthorWithCurrentUser(){
            this.act_author_firstname = this.$props.current_user.firstname;
            this.act_author_lastname = this.$props.current_user.lastname;
            this.act_author_position = this.$props.current_user.position;
        },
        populateActDataWithCurrentUser()
        {
            this.act_giver_firstname = this.$props.current_user.firstname;
            this.act_giver_lastname = this.$props.current_user.lastname;
            this.act_giver_position = this.$props.current_user.position;
        },
        populateActPersonInChargeWithCurrentUser()
        {
          this.act_receiver_person_in_charge_firstname = this.$props.current_user.firstname;
          this.act_receiver_person_in_charge_lastname = this.$props.current_user.lastname;
          this.act_receiver_person_in_charge_position = this.$props.current_user.position;
        },
        populateWithDataFromAgreement(){
          this.act_receiver_type = this.agreement_receiver_type;
          this.act_receiver_institution_name = this.agreement_receiver_institution_name;
          this.act_receiver_firstname = this.agreement_receiver_firstname;
          this.act_receiver_lastname = this.agreement_receiver_lastname;
          this.act_receiver_address = this.agreement_receiver_address;
          this.act_receiver_reg_nr = this.agreement_receiver_reg_nr;
          this.act_receiver_position = this.agreement_receiver_position;
        },
        changeSection(section)
        {
            this.section = section;
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/external-acts/remove-item-from-list/' + that.id,
                            {
                                item_id: item_id
                            }).then(response => {
                            if (response.data.status == 'ok') {
                                that.items = response.data.act.items;
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'info') {
                                that.$toast.warning(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                that.$toast.warning(response.data.message);
                            }
                        });
                    }});
        },

      save()
      {
          var that = this;
          var data = {
              agreement_number: this.agreement_number,
              agreement_date: this.agreement_date,
              agreement_receive_date: this.agreement_receive_date,
              agreement_extend_date: this.agreement_extend_date,
              agreement_giver_firstname: this.agreement_giver_firstname,
              agreement_giver_lastname: this.agreement_giver_lastname,
              agreement_giver_position: this.agreement_giver_position,
              agreement_giver_legal_basis: this.agreement_giver_legal_basis,
              agreement_receiver_type: this.agreement_receiver_type,
              agreement_receiver_institution_name: this.agreement_receiver_institution_name,
              agreement_receiver_position: this.agreement_receiver_position,
              agreement_receiver_firstname: this.agreement_receiver_firstname,
              agreement_receiver_lastname: this.agreement_receiver_lastname,
              agreement_receiver_address: this.agreement_receiver_address,
              agreement_receiver_reg_nr: this.agreement_receiver_reg_nr,
              agreement_storage_address: this.agreement_storage_address,
              agreement_due_date: this.agreement_due_date,
              agreement_standard_fee_eur: this.agreement_standard_fee_eur,
              agreement_usage_fee_eur: this.agreement_usage_fee_eur,
              agreement_total_fee_eur: this.agreement_total_fee_eur,
              agreement_fee_due_date: this.agreement_fee_due_date,
              agreement_page_count: this.agreement_page_count,
              agreement_special_rules: this.agreement_special_rules,
              agreement_receiver_bank_title: this.agreement_receiver_bank_title,
              agreement_receiver_bank_code: this.agreement_receiver_bank_code,
              agreement_receiver_bank_account_number: this.agreement_receiver_bank_account_number,
              act_number: this.act_number,
              purpose: this.purpose,
              act_giver_firstname: this.act_giver_firstname,
              act_giver_lastname: this.act_giver_lastname,
              act_giver_position: this.act_giver_position,
              act_giver_legal_basis: this.act_giver_legal_basis,
              act_receiver_type: this.act_receiver_type,
              act_receiver_institution_name: this.act_receiver_institution_name,
              act_receiver_position: this.act_receiver_position,
              act_receiver_firstname: this.act_receiver_firstname,
              act_receiver_lastname: this.act_receiver_lastname,
              act_receiver_address: this.act_receiver_address,
              act_receiver_reg_nr: this.act_receiver_reg_nr,
              act_due_date: this.act_due_date,
              act_author_position: this.act_author_position,
              act_author_firstname: this.act_author_firstname,
              act_author_lastname: this.act_author_lastname,
              act_date: this.act_date,
              annex_to_the_act: this.annex_to_the_act,
              act_type:this.act_type,
              reference_act_id:this.reference_act_id,
              notes: this.notes,
              act_basis: this.act_basis,
              receiver_contact_person: this.receiver_contact_person,
              giver_contact_person: this.giver_contact_person,
              act_receiver_person_in_charge_firstname: this.act_receiver_person_in_charge_firstname,
              act_receiver_person_in_charge_lastname: this.act_receiver_person_in_charge_lastname,
              act_receiver_person_in_charge_position: this.act_receiver_person_in_charge_position,

          }
          axios.post('/external-acts/update/'+that.id, data).then(response =>{
              if(response.data.status == 'ok')
              {
                  that.loading = false;
                  that.$toast.open(response.data.message);
              }
              else {
                  that.$toast.error(response.data.message);
              }
          });

      }
    },
    data()
    {
        return{
            id:"",
            agreement_number:"",
            agreement_date:"",
            agreement_receive_date:"",
            agreement_extend_date:"",
            agreement_giver_firstname:"",
            agreement_giver_lastname:"",
            agreement_giver_position:"",
            agreement_giver_legal_basis:"",
            agreement_receiver_type:"",
            agreement_receiver_institution_name:"",
            agreement_receiver_position:"",
            agreement_receiver_firstname:"",
            agreement_receiver_lastname:"",
            agreement_receiver_address:"",
            agreement_receiver_reg_nr:"",
            agreement_storage_address:"",
            agreement_due_date:"",
            agreement_standard_fee_eur:"",
            agreement_usage_fee_eur:"",
            agreement_total_fee_eur:"",
            agreement_fee_due_date:"",
            agreement_page_count:"",
            agreement_special_rules:"",
            agreement_receiver_bank_title:"",
            agreement_receiver_bank_code:"",
            agreement_receiver_bank_account_number:"",
            act_giver_firstname:"",
            act_number:"",
            purpose:"",
            act_giver_lastname:"",
            act_giver_position:"",
            act_giver_legal_basis:"",
            act_receiver_type:"",
            act_receiver_institution_name:"",
            act_receiver_position:"",
            act_receiver_firstname:"",
            act_receiver_lastname:"",
            act_receiver_address:"",
            act_receiver_reg_nr:"",
            act_due_date:"",
            act_author_position:"",
            act_author_firstname:"",
            act_author_lastname:"",
            act_date:"",
            act_basis:"",

            act_type:"",
            reference_act_id:"",


            annex_to_the_act:"",
            receiver_contact_person:"",
            giver_contact_person:"",
            act_receiver_person_in_charge_firstname:"",
            act_receiver_person_in_charge_lastname:"",
            act_receiver_person_in_charge_position:"",
            notes:"",
            items:[],

            section:"agreement",
            loading:false,

        }
    },
    computed:{
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>
